// 由 download.js 改造而来，下载 url，并支持自定义文件名

import { saveAs } from 'file-saver'

export const sjDownload = function (url, headers, fileName) {
  if (!url) {
    throw new Error(`url链接为空，无法下载。`)
  }

  fileName = fileName || url.split('/').pop().split('?')[0]
  return fetch(url, {
    method: 'GET',
    headers
  })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

      return response.blob()
    })
    .then(blob => {
      saveAs(blob, fileName)
      return blob
    })
    .catch(error => {
      console.error('Download error:', error)
      throw error // 将错误继续抛出，让调用者可以捕获
    })
}



// WEBPACK FOOTER //
// ./src/vendor/sj-download.js